import styled from "styled-components";
import GenericHeader from "../../../Componentes/GenericHeader";
import FilterContainer from "../../../Componentes/Utils/FilterContainer";
import Filters from "../../../Componentes/Utils/Filters";
import { useEffect, useMemo, useRef, useState } from "react";
import { TbLoader2 } from "react-icons/tb";
import axios from "axios";
import { formatarData } from "../../../Funcoes/FormatarData";
import { useModal } from "../../../contexts/ModalContext";
import Overlay from "../../../Componentes/Overlay";
import SideMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import ModalNovoDesvio from "./ModalNovoDesvio";
import AreasCatalogo from "./AreasCatalogo";
import ModalCatalogoCategRisco from "./ModalCatalogoCategRisco";
import MultiselectCheck from "../../../Componentes/Utils/MultiselectCheck";
import ModalViewDesvio from "./ModalViewDesvio";
import { useNavigate } from "react-router-dom";

const ContainerTabela = styled.div`
    width: 100%;
    flex: 1;
    background-color: #f3f3f3;
    border-radius: 8px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
        height: 8px;
        width: 12px;
        background-color: #f0f0f0;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
        border: 3px solid #f0f0f0;
        border-radius: 8px;
    }
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        th {
            text-align: left;
            padding-left: 12px;
            font-weight: bold;
            white-space: nowrap;
            padding-right: 5px;
        }
        th:last-child{
            padding-right: 15px;
        }
        tr{
            height: 40px;
        }
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    }
    tbody {
        tr {
            height: 35px;
            border-bottom: 1px solid #e1e1e1;
            &:nth-child(even) {
                background-color: #f9f9f9;
            }
            &:nth-child(odd) {
                background-color: #ffffff;
            }
            &:last-child {
                border-bottom: none;
            }
            td {
                padding-left: 12px;
                white-space: nowrap;
                padding-right: 5px;
            }
            &:hover {
                background-color: #e8f0fe;
            }
        }
    }
`
const ContainerLoading = styled.div`
    margin: auto;
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
`
const ContainerIcon = styled.div`
    width: 35px;
    height: 35px;
    margin: auto auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const IconeLoading = styled(TbLoader2)`
    width: 100%;
    height: 100%;
    animation: spin 2s linear infinite;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`
const TextoLoading = styled.p`
    margin: 5px auto auto auto;
    font-weight: bold;
    font-size: 14px;
`
const Statistics = styled.div`
    width: 350px;
    @media (max-width: 768px) {
        width: 100%;
        padding: 15px 10px;
    }
    height: 100%;
    background-color: #f3f3f3;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;
`
const ContainerStatistic = styled.div`
    width: 100%;
    height: 100%;
    background-color: #f3f3f3;
    display: flex;
    flex-direction: column;
    gap: 3px;
    justify-content: center;
`
const InfoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

const StatsInfoSide = styled.div`
    width: 45%;
`
const TituloStatistic = styled.h3`
    text-align: center;
    margin: 0;
    padding: 0;
    font-size: 13px;
    font-weight: bold;
    color: #000;
`
const TextoStatistic = styled.p`
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #333;
`

const Content = () => {

    const { openModal, isModalOpen, closeModal } = useModal();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);

    const fetchData = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetDesvios/', {
                withCredentials: true
            });
            setData(data);
            setDataFiltered(data)

            console.log(data);

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        fetchData();

    }, []);

    const [linhas, setLinhas] = useState(100);
    const containerRef = useRef(null);

    const verifyHeight = () => {

        const container = containerRef.current;

        if (container.scrollTop + container.clientHeight >= container.scrollHeight) {

            if (linhas >= dataFiltered.length) return;
            setLinhas(prev => prev + 100);

        }

    }

    const openNewDesvio = () => {

        closeModal();
        openModal('modalNovoDesvio');

    }

    const openCatalogoAreas = () => {

        closeModal();
        openModal('catalogoAreasDesvios');

    }

    const listaObras = useMemo(() => [...new Set(data.map((obj) => obj.centro_custo))].sort(), [data]).filter(obra => obra && obra.trim() !== "");
    const listaContratos = useMemo(() => [...new Set(data.map((obj) => obj.contrato))].sort(), [data]).filter(ct => ct && ct.trim() !== "");
    const listaResponsaveis = useMemo(() => [...new Set(data.map((obj) => obj.usuario))].sort(), [data])
    const listaEquipes = useMemo(() => [...new Set(data.map((obj) => obj.equipe))].sort(), [data])

    const openCatalogoCategRisco = () => {

        closeModal();
        openModal('catalogoCategRiscoDesvios');

    }

    const [columns, setColumns] = useState(4);

    useEffect(() => {

        const handleResize = () => {
            if (window.innerWidth < 800) {
                setColumns(2);
            } else {
                setColumns(4);
            }
        }

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }

    }, [])

    const [selectedObras, setSelectedObras] = useState([]);
    const [selectedContratos, setSelectedContratos] = useState([]);
    const [selectedResponsaveis, setSelectedResponsaveis] = useState([]);
    const [selectedEquipes, setSelectedEquipes] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedClassificacao, setSelectedClassificacao] = useState([]);

    const [dataInicio, setDataInicio] = useState(null);
    const [dataFim, setDataFim] = useState(null);

    useEffect(() => {

        let filtered = data;

        if (selectedObras.length > 0) { filtered = filtered.filter(item => selectedObras.includes(item.centro_custo)) }
        if (selectedContratos.length > 0) { filtered = filtered.filter(item => selectedContratos.includes(item.contrato)) }
        if (selectedResponsaveis.length > 0) { filtered = filtered.filter(item => selectedResponsaveis.includes(item.usuario)) }
        if (selectedEquipes.length > 0) { filtered = filtered.filter(item => selectedEquipes.includes(item.equipe)) }
        if (selectedStatus.length > 0) { filtered = filtered.filter(item => selectedStatus.includes(item.resolvido === 1 ? "FINALIZADO" : "PENDENTE")) }
        if (selectedClassificacao.length > 0) { filtered = filtered.filter(item => selectedClassificacao.includes(item.classificacao_risco)) }

        if (dataInicio) {
            const inicio = new Date(dataInicio);
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.data_ocorrido);
                return itemDate >= inicio;
            });
        }
        if (dataFim) {
            const fim = new Date(dataFim);
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.data_ocorrido);
                return itemDate <= fim;
            });
        }

        setDataFiltered(filtered);

    }, [selectedObras, selectedContratos, selectedResponsaveis, selectedEquipes, selectedStatus, selectedClassificacao, data, dataInicio, dataFim])

    const [desvioSelected, setDesvioSelected] = useState(null);

    const openDesvio = (obj) => {

        setDesvioSelected(obj);
        openModal('modalViewDesvio');

    }

    const fecharViewDesvio = () => {

        setDesvioSelected(null);
        closeModal();

    }

    return (
        <>
            <GenericHeader responsive >
                <Filters
                    columns={columns}
                >
                    <MultiselectCheck
                        options={listaObras.map(obra => ({ value: obra, label: obra }))}
                        selectedOptions={selectedObras}
                        setSelectedOptions={setSelectedObras}
                        placeholder="CENTRO CUSTO..."
                    />
                    <MultiselectCheck
                        options={listaContratos.map(contrato => ({ value: contrato, label: contrato }))}
                        selectedOptions={selectedContratos}
                        setSelectedOptions={setSelectedContratos}
                        placeholder="CONTRATO..."
                    />
                    <MultiselectCheck
                        options={listaResponsaveis.map(resp => ({ value: resp, label: resp }))}
                        selectedOptions={selectedResponsaveis}
                        setSelectedOptions={setSelectedResponsaveis}
                        placeholder="RESPONSÁVEL..."
                    />
                    <MultiselectCheck
                        options={listaEquipes.map(equipe => ({ value: equipe, label: equipe }))}
                        selectedOptions={selectedEquipes}
                        setSelectedOptions={setSelectedEquipes}
                        placeholder="EQUIPE..."
                    />
                    <MultiselectCheck
                        options={[
                            { value: 'FINALIZADO', label: "FINALIZADOS" },
                            { value: 'PENDENTE', label: "PENDENTES" }
                        ]}
                        selectedOptions={selectedStatus}
                        setSelectedOptions={setSelectedStatus}
                        placeholder="STATUS..."
                    />
                    <MultiselectCheck
                        options={[
                            { value: "MODERADO", label: "MODERADO" },
                            { value: "ALTO", label: "ALTO" }
                        ]}
                        selectedOptions={selectedClassificacao}
                        setSelectedOptions={setSelectedClassificacao}
                        placeholder="CLASSIFICAÇÃO..."
                    />
                    <FilterContainer
                        type="date"
                        valor={dataInicio}
                        changeFunc={(value) => setDataInicio(value)}
                    />
                    <FilterContainer
                        type="date"
                        valor={dataFim}
                        changeFunc={(value) => setDataFim(value)}
                    />
                </Filters>
                <Statistics>
                    <ContainerStatistic>
                        <TituloStatistic>DESVIOS: {dataFiltered.length}</TituloStatistic>
                        <InfoContainer>
                            <StatsInfoSide>
                                <TextoStatistic>FINALIZADOS: {dataFiltered.filter(item => item.resolvido === 1).length}</TextoStatistic>
                                <TextoStatistic>PENDENTES: {dataFiltered.filter(item => item.resolvido !== 1).length}</TextoStatistic>
                            </StatsInfoSide>
                            <StatsInfoSide>
                                <TextoStatistic>MODERADOS: {dataFiltered.filter(item => item.classificacao_risco === 'MODERADO').length}</TextoStatistic>
                                <TextoStatistic>ALTOS: {dataFiltered.filter(item => item.classificacao_risco === 'ALTO').length}</TextoStatistic>
                            </StatsInfoSide>
                        </InfoContainer>
                    </ContainerStatistic>
                </Statistics>
            </GenericHeader>
            <ContainerTabela ref={containerRef} onScroll={verifyHeight} >
                {loading
                    ? <ContainerLoading>
                        <ContainerIcon>
                            <IconeLoading />
                        </ContainerIcon>
                        <TextoLoading>CARREGANDO...</TextoLoading>
                    </ContainerLoading>
                    : <Tabela>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>CENTRO CUSTO</th>
                                <th>CONTRATO</th>
                                <th>ÁREA</th>
                                <th>EQUIPE</th>
                                <th>LÍDER</th>
                                <th>USUÁRIO</th>
                                <th>DATA</th>
                                <th>CLASSIFICAÇÃO</th>
                                <th>RESOLUÇÃO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataFiltered.slice(0, linhas).map((item) => (
                                <tr key={item.id}
                                    onClick={() => openDesvio(item)}
                                >
                                    <td>{item.id}</td>
                                    <td>{item.centro_custo}</td>
                                    <td>{item.contrato}</td>
                                    <td>{item.area}</td>
                                    <td>{item.equipe}</td>
                                    <td>{item.lider_imediato}</td>
                                    <td>{item.usuario}</td>
                                    <td>{item.data_ocorrido ? formatarData(item.data_ocorrido) : "-"}</td>
                                    <td>{item.classificacao_risco}</td>
                                    <td>{ item.resolvido === 1 ? "FINALIZADO" : "PENDENTE" }</td>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                }
            </ContainerTabela>
            {
                isModalOpen('sidebarDesvios') && (
                    <Overlay state={true} changeContent={closeModal} >
                        <SideMenu>
                            <SideMenuBtn
                                button="CATALOGO ÁREAS"
                                clickFunc={openCatalogoAreas}
                            />
                            <SideMenuBtn
                                button="CATALOGO RISCOS"
                                clickFunc={openCatalogoCategRisco}
                            />
                            <SideMenuBtn
                                button="INVESTIGAÇÕES"
                                clickFunc={() => { 
                                    closeModal();
                                    navigate('./investigacao');
                                }}
                            />
                            <SideMenuBtn
                                button="METAS"
                                clickFunc={() => {
                                    closeModal();
                                    navigate('./metas');
                                }}
                            />
                            <SideMenuBtn
                                button="NOVO DESVIO"
                                clickFunc={openNewDesvio}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('modalNovoDesvio') && (
                    <ModalNovoDesvio
                        onSave={ fetchData }
                    />
                )
            }
            {
                isModalOpen('catalogoAreasDesvios') && (
                    <AreasCatalogo />
                )
            }
            {
                isModalOpen('catalogoCategRiscoDesvios') && (
                    <ModalCatalogoCategRisco />
                )
            }
            {
                isModalOpen('modalViewDesvio') && (
                    <ModalViewDesvio
                        desvio={ desvioSelected }
                        fechar={ fecharViewDesvio }
                        updateData={ fetchData }
                    />
                )
            }
        </>
    )
}

export default Content;